export const getFormData = (obj) => {
  const formData = new FormData()
  for (let i in obj) {
    // // console.log(i, obj[i])
    formData.append(i, obj[i])
  }
  return formData
}
